import dynamic from 'next/dynamic';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'normalize.css';
import './global.css';

export default dynamic(() => import('./App'), {
  ssr: false,
});
